export interface IFormatPositionAtCompanyParams {
  position?: string;
  company?: string;
}

export const formatPositionAtCompany = ({ position = '', company = '' }: IFormatPositionAtCompanyParams): string =>
  company && position ? `${position} at ${company}` : company;
